import { BCMSCurrency, BrandingStyle, useStateManager } from "@bcm-dev/bcms-vite";
import React from "react";

import './styles.css';

/**
 * @function TransactionSearchCriteria
 * @param {OBJECT} controller - The controller passed from the AccountDetailsPage to get the state of the filter
 * @return {React.Component}
 * @exported true
 * @description Component to show what criteria has been set in the filter
 * @example
 * <TransactionSearchCriteria  />
 */
export default function TransactionSearchCriteria(props) {
    const { data, ui, onSearchReset } = useStateManager();
    const search = data.submittedSearch;

    // getCriteriaString :: STRING -> STRING
    // function for build the criteria string based on what was set in the form
    const getCriteriaString = key => {
        const value = search[key];

        switch(key) {
            case "type": return `Transaction Type: ${ search.types.get(value) }`;
            case "date": return `Date Range: ${ search.ranges.get(value) }`;
            case "description": return `Description: ${ value }`;
            case "amount": return `Amount: ${ BCMSCurrency.init(value).format() }`;
            case "check": return `Check Number: ${ value }`;
        }
    };

    // Build the criteria string
    const searchCriteria = ["type", "date", "amount", "description", "check"].reduce((result, key) => {
        if(Object.keys(search.filters).includes(key)) {
            result += `${ getCriteriaString(key) }; `;
        }

        return result;
    }, "");

    return (
        <BrandingStyle style={{ "backgroundColor": "search_bg_abi22" }}
        className="flex-container flex-horizontal transaction-search-criteria"
        element={
            <div >
                <BrandingStyle style={{ "color": "search_text_abi22" }} element={<p><b>Displaying: </b><span>{searchCriteria}</span></p>} /> 
                { ui.searchClearSearchButton.isActive &&
                    <a className="text-right clickable" onClick={ onSearchReset }>Clear Search</a> 
                }
            </div>
        } />
    );
}